import { render, staticRenderFns } from "./IconBtnSoundOff.vue?vue&type=template&id=f2bb2518"
import script from "./IconBtnSoundOff.vue?vue&type=script&lang=js"
export * from "./IconBtnSoundOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports